// extracted by mini-css-extract-plugin
export var aboveInput = "_fq-0";
export var actionButton = "_fq-5";
export var actionButtonContainer = "_fq-1";
export var actionIcon = "_fq-6";
export var aiInfoContainer = "_fq-2";
export var attachmentWrapper = "_fq-7";
export var bold = "_fq-3";
export var checkIcon = "_fq-8";
export var clickingRecipientBar = "_fq-11";
export var commentThreadSwitch = "_fq-a";
export var draftImage = "_fq-b";
export var draftImageContainer = "_fq-c";
export var draftImages = "_fq-e";
export var editButton = "_fq-g";
export var editor = "_fq-f";
export var editorContainer = "_fq-y";
export var editorErrorTooltipWrapper = "_fq-9";
export var headerDivider = "_fq-h";
export var icon = "_fq-i";
export var info = "_fq-j";
export var internal = "_fq-n";
export var internalDivider = "_fq-k";
export var internalMessage = "_fq-l";
export var messageInputCard = "_fq-m";
export var messageInputForm = "_fq-o";
export var messageInputFormInternal = "_fq-p";
export var options = "_fq-q";
export var publicMessageCustomer = "_fq-s";
export var publicMessageMerchant = "_fq-r";
export var removeImageButton = "_fq-d";
export var replyButtons = "_fq-t";
export var showSignatureButton = "_fq-u";
export var spinner = "_fq-v";
export var verticalButtonDivider = "_fq-4";
export var visibilitySelector = "_fq-w";
export var warning = "_fq-x";
export var wrappingText = "_fq-z";
export var writingInternalNoteTopBorder = "_fq-10";